import React from 'react'

import { connect } from 'react-redux'
import Operations from '../../../../operations'
import Selectors from '../../../../selectors'

import {
  EmarModuleCard,
  FamilyPlanModuleCard,
  PaywallTemplate,
} from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { HomeSource } from '@lmc/ts-common'

interface StateProps {
  subscribeTo: () => void
  getSubscriptions: () => void
  subscriptionCancelled: boolean
  role: string
  source?: HomeSource
}

const ZonesPaywallComponent: React.FC<StateProps> = ({
  subscribeTo,
  getSubscriptions,
  subscriptionCancelled,
  role,
  source,
}) => {
  React.useEffect(() => {
    getSubscriptions()
  }, [])

  const ctaDisabled = role === 'senior-carer' || subscriptionCancelled
  let disabledText
  if (subscriptionCancelled) {
    disabledText = 'Note: Sorry, you have already completed a free trial.'
  } else if (role === 'senior-carer') {
    disabledText = 'Note: Only admins can start a free trial.'
  }

  return (
    <PaywallTemplate
      backgroundColor={colours.status.popout}
      title="Zones"
      subTitle="Group your service users into zones, e.g. based on floors, wings, or even beds."
      bodyText="Help your team navigate their way around."
      cta="Start Free Trial"
      onClick={subscribeTo}
      icon={IconType.ProHexagon}
      videoUrl="https://www.youtube.com/embed/R6-VlPq0m9o"
      articles={[
        {
          title: 'How do I set up zones?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/3046855-how-do-i-set-up-zones',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'How do I select a zone?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/3054739-how-do-i-select-a-zone',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      ctaDisabled={ctaDisabled}
      disabledText={disabledText}
      findOutMoreURL="https://logmycare.co.uk/features/service-efficiency"
      customLinkText="Read more"
      source={source}
    />
  )
}

const mapStateToProps = (state: any) => ({
  subscriptionCancelled: Selectors.isSubscriptionCancelled(
    state,
    'pro-monthly'
  ),
  role: state.global?.user?.role,
  source: state.global?.home?.source,
})

const mapDispatchToProps = (dispatch: any) => ({
  subscribeTo: () =>
    dispatch(
      Operations.openNewPlan({
        planId: 'pro-monthly',
      })
    ),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
})

export const ZonesPaywall = connect(
  mapStateToProps,
  mapDispatchToProps
)(ZonesPaywallComponent)
